import classNames from 'classnames';
import React from 'react';
import styles from './Button.scss';
var ButtonColorStyle;
(function (ButtonColorStyle) {
    ButtonColorStyle["COLORED"] = "colored";
    ButtonColorStyle["DEFAULT"] = "default";
    ButtonColorStyle["ERROR"] = "error";
    ButtonColorStyle["GREEN"] = "green";
    ButtonColorStyle["LINK"] = "link";
    ButtonColorStyle["OUTLINE"] = "outline";
    ButtonColorStyle["TRANSPARENT"] = "transparent";
    ButtonColorStyle["WHITE"] = "white";
    ButtonColorStyle["WSR"] = "wsr";
})(ButtonColorStyle || (ButtonColorStyle = {}));
var ButtonSize;
(function (ButtonSize) {
    ButtonSize["LARGE"] = "large";
    ButtonSize["MEDIUM"] = "medium";
    ButtonSize["XSMALL"] = "xsmall";
})(ButtonSize || (ButtonSize = {}));
var Button = function (_a) {
    var _b;
    var autoFocus = _a.autoFocus, children = _a.children, form = _a.form, dataHook = _a.dataHook, icon = _a.icon, _c = _a.colorStyle, colorStyle = _c === void 0 ? ButtonColorStyle.DEFAULT : _c, _d = _a.size, size = _d === void 0 ? ButtonSize.MEDIUM : _d, onClick = _a.onClick, disabled = _a.disabled, className = _a.className;
    var styleName = classNames(styles.button, colorStyle === ButtonColorStyle.DEFAULT ? undefined : styles[colorStyle], styles[size], (_b = {},
        _b[styles.disabled] = disabled,
        _b), className);
    icon =
        icon &&
            React.cloneElement(icon, {
                className: classNames(styles.buttonIcon, icon.props.className),
            });
    return (React.createElement("button", { autoFocus: autoFocus, form: form, "data-hook": dataHook, className: styleName, onClick: onClick, disabled: disabled },
        icon,
        children));
};
export { ButtonColorStyle, ButtonSize };
export default Button;
//# sourceMappingURL=Button.js.map